import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Spinner, Table } from 'react-bootstrap';

const MissingMonitoring = (props) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();

  useEffect(() => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_TRAPLOG_API_URL}api/missing-monitoring`, {
      headers: {
        Authorization: `Bearer ${props.bearerToken}`,
        Accept: 'application/json',
        SeasonalDatabase: props.selectedDatabase
      }
    })
      .then((res) => {
        if (res.ok) return res.json();
        if (res.status === 401) props.refreshBearerToken();
        else throw Error(res.statusText);
      })
      .then((data) => {
        setData(data);
      })
      .catch((err) => {
        if (process.env.NODE_ENV === 'development') console.error(err);
        setData(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [props.bearerToken, props.selectedDatabase]);

  return loading ? (
    <Spinner variant='primary' animation='border' />
  ) : data ? (
    <Table>
      <thead>
        <tr>
          <th>Property Identifier</th>
          <th>Property Name</th>
          <th>Production Site</th>
          <th>Trap Type</th>
          <th>Last Visited Date</th>
          <th>Total Traps</th>
          <th>Monitored Traps</th>
        </tr>
      </thead>
      <tbody>
        {data.map((point, i) => (
          <tr key={i}>
            <td>{point.identifier}</td>
            <td>{point.property}</td>
            <td>{point.production_area}</td>
            <td>{point.insect_group_name}</td>
            <td>{point.last_visited_date}</td>
            <td>{point.traps}</td>
            <td>{point.monitored_traps}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  ) : null;
};

MissingMonitoring.propTypes = {
  selectedDatabase: PropTypes.string.isRequired,
  bearerToken: PropTypes.string.isRequired,
  refreshBearerToken: PropTypes.func.isRequired
};

export default observer(MissingMonitoring);
